import styled from "styled-components";
import { color } from "@styles";
import { mobile } from "components/templates/Breakpoints";
import { Button } from "components/atoms/Button";
import { P2 } from "components/atoms/Paragraph";
import { Cookie } from "components/atoms/svgs/Cookie";

export const StyledContainer = styled.aside`
  position: fixed;
  bottom: 0;
  right: 2rem;
  text-align: left;
  z-index: 10;
  max-width: 30rem;
  margin: 0 auto;
  padding: 1.5rem 1.5rem 1.5rem 0;
  background: ${color.B220};
  border-top: 1px solid ${color.B230};
  border-left: 1px solid ${color.B230};
  border-right: 1px solid ${color.B230};
  box-sizing: border-box;
  border-radius: 0.5rem 0.5rem 0 0;
  display: flex;
  flex-direction: row;

  ${mobile} {
    left: -1px;
    bottom: -1px;
    padding-left: 1.5rem;
    gap: 1rem;
    width: calc(100% + 2px);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const StyledCloseBtn = styled.button`
  position: absolute;
  right: 1rem;
  top: 1rem;

  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;

export const StyledCookie = styled(Cookie)`
  flex: 0.2;

  ${mobile} {
    flex: 0.1;
  }
`;

export const StyledButton = styled(Button)`
  margin: 0;
  padding: 0;
  height: 3.25rem;
  font-size: 1rem;
  font-weight: bold;
  padding: 1rem;
  max-width: 10rem;

  ${mobile} {
    flex: none;
  }
`;

export const StyledText = styled(P2)`
  font-size: 14px;
  line-height: 1.6rem;
  letter-spacing: 1.2px;
  color: ${color.B1100};
  padding: 0 1rem 0 0;
`;

export const FlexCol = styled.div<{ spacing: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1;
  flex: 0.8;

  & > *:not(:first-child) {
    margin-top: ${(props) => props.spacing};
  }
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  ${mobile} {
    flex-direction: column;
  }
`;
